import styled from "@emotion/styled/macro";
import isStyledPropsValid from "utils/isStyledPropsValid";

export const StyledDropdown = styled("div", {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, open, noBorder }) => {
  return {
    cursor: "pointer",
    background: "#FFFFFF",
    padding: 8,
    fontSize: 14,
    fontWeight: "500",
    paddingRight: 4,
    height: 32,
    borderRadius: 3,
    color: "#555555",
    display: "inline-flex",
    alignItems: "center",
    border: open ? "1px solid #7B61FF" : "1px solid #E6E6E6",
    ...(noBorder && { border: "none" }),
  };
});
